import { useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import CustomTooltip from '@shared/components/Tooltip';

import RenderRadio from './RenderRadio';
import RenderTitlesArrival from './RenderTitlesArrival';
import RenderDetailScales from './RenderDetailScales';
import RenderAirline from './RenderAirline';
import RenderBaggageIcons from '@FlightsComponents/RenderBaggageIcons';
import RenderScale from './RenderScale';

import { sxStyle } from './styles';
import SectionGrid from '@shared/components/SectionGrid';

const HeaderAcordeon = ({
  object_option,
  indexLeg,
  title,
  index,
  handleRadio,
  activeRadio,
  next_leg_options,
  next_cluster,
}) => {
  const [baggageTooltip, setBaggageTooltip] = useState(null);
  const [scalesTooltip, setScalesTooltip] = useState(null);

  const returnTime = time => time.slice(11, 16);
  const handleEnter = (key, setter) => setter(key);
  const handleLeave = setter => setter(null);

  // ----- LAYOUT POR BREAKPOINTS -----
  const customLayout = {
    xs: {
      1: 1.4, // Radio
      2: 1.3, // Airline (logo)
      3: 7.3, // Info + Escalas → prioridad máxima
      4: 2, // Baggage
    },
    sm: {
      1: 2,
      2: 2,
      3: 6,
      4: 2,
    },
    md: {
      1: 1,
      2: 2,
      3: 7,
      4: 2,
    },
    lg: {
      1: 1,
      2: 2,
      3: 7,
      4: 2,
    },
  };

  // ----- ESTILOS POR ITEM -----
  const customItemSx = {
    1: { display: 'flex', justifyContent: 'center', alignItems: 'center' }, // Radio
    2: { display: 'flex', justifyContent: 'center', alignItems: 'center' }, // Airline
    3: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }, // Info + Escalas
    4: { display: 'flex', justifyContent: 'center', alignItems: 'center' }, // Baggage
  };

  return (
    <SectionGrid
      spacing={2}
      customLayout={customLayout}
      customItemSx={customItemSx}
      padding="8px"
    >
      {/* 1️⃣ RADIO */}
      <RenderRadio
        key="radio"
        activeRadio={activeRadio}
        handleRadio={handleRadio}
        indexLeg={indexLeg}
        object_option={object_option}
        next_cluster={next_cluster}
        next_leg_options={next_leg_options}
      />

      {/* 2️⃣ AIRLINE */}
      <Box key="airline" display="flex" alignItems="center">
        <RenderAirline {...{ object_option }} />
      </Box>

      {/* 3️⃣ INFO + ESCALAS */}
      <Box
        key="info"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <RenderTitlesArrival {...{ object_option }} />

        <Box
          sx={{ ...sxStyle.centerBaggage }}
          onMouseEnter={() =>
            handleEnter('ScalesIDA' + index, setScalesTooltip)
          }
          onMouseLeave={() => handleLeave(setScalesTooltip)}
        >
          <RenderScale {...{ object_option }} />
          <CustomTooltip
            anchor={scalesTooltip}
            elementId={'ScalesIDA' + index}
            stylesProp={{ top: '50px', alignItems: 'center' }}
          >
            <RenderDetailScales {...{ object_option }} />
          </CustomTooltip>
        </Box>

        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>
            {returnTime(object_option.arrival)}
          </Typography>
          <Typography sx={{ fontSize: '1rem', color: '#6A6A6A' }}>
            {object_option.destination_airport}
          </Typography>
        </Box>
      </Box>

      {/* 4️⃣ BAGGAGE */}
      <Box
        key="baggage"
        display="flex"
        flexDirection="column"
        alignItems="center"
        onMouseEnter={() => handleEnter(title + index, setBaggageTooltip)}
        onMouseLeave={() => handleLeave(setBaggageTooltip)}
      >
        <Typography sx={sxStyle.equipaje}>Equipaje</Typography>
        <RenderBaggageIcons
          baggage={object_option.flight_baggage}
          transform={{ xs: 'scale(0.8)', sm: 'scale(0.9)' }}
        />

        <CustomTooltip
          anchor={baggageTooltip}
          elementId={title + index}
          stylesProp={{ top: '80px', marginLeft: '5px' }}
        >
          <Typography
            color="inherit"
            sx={{
              fontWeight: 600,
              lineHeight: 1,
              whiteSpace: 'nowrap',
              fontSize: 14,
            }}
          >
            Detalle de equipaje
          </Typography>

          <Divider sx={{ m: '5px' }} />

          {object_option.flight_baggage?.backpack_baggage && (
            <Typography sx={{ fontSize: 12 }}>Objeto personal</Typography>
          )}
          {object_option.flight_baggage?.hand_baggage && (
            <Typography sx={{ fontSize: 12 }}>Equipaje de mano</Typography>
          )}
          {object_option.flight_baggage?.baggage_hold && (
            <Typography sx={{ fontSize: 12 }}>Equipaje de bodega</Typography>
          )}
        </CustomTooltip>
      </Box>
    </SectionGrid>
  );
};

export default HeaderAcordeon;
